export const AffectLoanPeriod = Object.freeze({
    RE_BUY: 're_buy',
    HOUSE_BUY: 'house_buy'
});